import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@/routing/rootRoute.ts';
import BookingErrorPage from '@/features/public/booking/pages/BookingErrorPage.tsx';

export const bookingNotFoundRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'booking/$orgSlug/$tourSlug/not-found',
  component: BookingErrorPage,
});
